import {
  useMutation,
  useQueryClient,
  type InfiniteData,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignQueryKeys } from "./queryKeys";

import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import { instance } from "@/lib/axios/instance";
import { AddCampaignRequest } from "@/types/request/AddCampaignRequest";
import { CampaignTypeDTO } from "@/types/response/CampaignType";
import { PagedResponse } from "@/types/response/PagedResponse";
import { ValidationErrorResponse } from "@/types/response/ValidationResponse";

export function useAddCampaignMutation(clientId?: string) {
  const queryClient = useQueryClient();
  return useMutation<
    CampaignTypeDTO,
    AxiosError<ValidationErrorResponse>,
    AddCampaignRequest
  >({
    mutationFn: (payload) =>
      instance
        .post<CampaignTypeDTO>("/api/v2/Campaigns", {
          ...payload,
          clientId2: clientId ?? null,
        })
        .then((res) => res.data),
    onSuccess: (newCampaign) => {
      queryClient.setQueriesData<
        InfiniteData<PagedResponse<CampaignTypeDTO>>
      >({ queryKey: campaignQueryKeys.infinites() }, (old) => {
        if (!old?.pages[0]) return old;
        return {
          ...old,
          pages: [
            {
              ...old.pages[0],
              data: [newCampaign, ...old.pages[0].data],
              totalRecords: old.pages[0].totalRecords + 1,
            },
            ...old.pages.slice(1),
          ],
        };
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: campaignQueryKeys.all,
        refetchType: "all",
      });
      queryClient.invalidateQueries({ queryKey: ["campaignJobBoardMonths"] });
      queryClient.invalidateQueries({
        queryKey: segmentsQueryKeys.all,
        refetchType: "all",
      });
    },
  });
}
